import { API_ENDPOINTS, API_HEADERS } from "../constants/api";

export interface TeamMemberPayload {
  id?: number;
  title: string;
  name: string;
  description: string;
  image: string;
  [key: string]: any;
}

export const fetchTeamMembers = async (): Promise<TeamMemberPayload[]> => {
  const response = await fetch(API_ENDPOINTS.team, {
    headers: API_HEADERS,
  });

  if (!response.ok) {
    throw new Error(`Team request failed with status ${response.status}`);
  }

  const data = await response.json();

  return Array.isArray(data) ? (data as TeamMemberPayload[]) : [];
};

